export default __webpack_public_path__ + "new-register-status-icon.svg";